@if(_propertiesService.isLoadingProperty$ | async){
<ng-container *ngTemplateOutlet="loadingSkeleton" />
} @else{
<div class="flex flex-col w-full h-full">
  <div class="flex flex-row items-center justify-between gap-2 mb-4">
    <app-breadcrumb [items]="breadcrumdItems" />

    <p-button
      class="hidden sm:block"
      severity="contrast"
      variant="outlined"
      (onClick)="onPropertyBookmark()"
    >
      @if (property?.isBookmarked) {
      <svg-icon
        src="assets/icons/bookmarks-filled.svg"
        svgClass="h-5 w-5 text-blue-500"
      />
      } @else{
      <svg-icon
        src="assets/icons/bookmarks.svg"
        svgClass="h-5 w-5 text-light-300"
      />
      } Bookmark
    </p-button>
  </div>

  <div class="flex flex-row items-center justify-between gap-2 mb-8">
    <div class="font-bold text-3xl text-light-300">
      {{ property?.images?.length }} photos
    </div>

    <p-button
      class="block sm:hidden"
      severity="contrast"
      variant="outlined"
      (onClick)="onPropertyBookmark()"
    >
      @if (property?.isBookmarked) {
      <svg-icon
        src="assets/icons/bookmarks-filled.svg"
        svgClass="h-5 w-5 text-blue-500"
      />
      } @else{
      <svg-icon
        src="assets/icons/bookmarks.svg"
        svgClass="h-5 w-5 text-light-300"
      />
      } Bookmark
    </p-button>
  </div>

  <div class="pb-8">
    @for (group of groupedImages; track $index) {
    <div
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 grid-rows-3 lg:grid-rows-2 gap-2 h-[290px] sm:h-[490px] mb-2"
    >
      @if ($index % 2 === 0) {
      <img
        [src]="group[0]"
        class="col-span-4 row-span-2 rounded-border h-full w-full object-cover cursor-pointer"
        (click)="onShowGallery($index * 3)"
      />

      @if(group[1]){
      <img
        [src]="group[1]"
        class="col-span-2 row-span-1 rounded-border h-full w-full object-cover cursor-pointer"
        (click)="onShowGallery($index * 3 + 1)"
      />
      }
      <!--  -->

      @if (group[2]) {
      <img
        [src]="group[2]"
        class="col-span-2 row-span-1 rounded-border h-full w-full object-cover cursor-pointer"
        (click)="onShowGallery($index * 3 + 2)"
      />
      }
      <!--  -->

      } @else {
      <img
        [src]="group[0]"
        class="col-span-2 row-span-1 rounded-border h-full w-full object-cover cursor-pointer"
        (click)="onShowGallery($index * 3)"
      />

      @if(group[2]){
      <img
        [src]="group[2]"
        class="col-span-4 row-span-2 rounded-border h-full w-full object-cover cursor-pointer"
        (click)="onShowGallery($index * 3 + 1)"
      />
      }
      <!--  -->

      @if(group[1]){
      <img
        [src]="group[1]"
        class="col-span-2 row-span-1 rounded-border h-full w-full object-cover cursor-pointer"
        (click)="onShowGallery($index * 3 + 2)"
      />
      }
      <!--  -->

      }
    </div>
    }
  </div>
</div>
}

<p-galleria
  [activeIndex]="selectedImageIndex"
  [value]="images"
  [(visible)]="displayBasic"
  [responsiveOptions]="[]"
  [containerStyle]="{ 'max-width': '80%' }"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [showThumbnails]="false"
>
  <ng-template #item let-item>
    <img [src]="item" style="width: 100%; display: block" />
  </ng-template>
</p-galleria>

<ng-template #loadingSkeleton>
  <div class="flex flex-row items-center justify-between gap-2 mb-4">
    <p-skeleton width="400px" height="30px" borderRadius="2" />
    <p-skeleton width="100px" height="41px" borderRadius="2" />
  </div>

  <div class="flex flex-col gap-10">
    <div class="relative grid grid-cols-6 grid-rows-2 gap-2 w-full h-[350px]">
      <div class="col-span-4 row-span-2">
        <p-skeleton width="100%" height="100%" borderRadius="2" />
      </div>

      <div class="col-span-2 row-span-1">
        <p-skeleton width="100%" height="100%" borderRadius="2" />
      </div>

      <div class="col-span-2 row-span-1">
        <p-skeleton width="100%" height="100%" borderRadius="2" />
      </div>
    </div>
  </div>
</ng-template>
